import React, { useEffect, useState } from "react";
import ApiDashboardJoyeria from "../../../../../js/api/env/global/DashboardJoyeria";
import { openNotification } from "../../../../controls/Notifications";
import { Pie } from "@ant-design/charts";
import { Typography } from "antd";

const { Title } = Typography;

const Dashboard30DiasJoyeria = () => {
  const [data30Dias, setData30Dias] = useState([]);
  useEffect(() => {
    Promise.all([ApiDashboardJoyeria.DatoHistorico(1, 2)])
      .then((res) => {
        const dashboard30Dias = res[0];

        if (dashboard30Dias.data.success) {
          console.log(dashboard30Dias);
          setData30Dias(dashboard30Dias.data.dataList);
        } else {
          openNotification(
            "e",
            "Carga de Datos",
            "Ocurrio un error en la carga de datos"
          );
        }
      })
      .catch((err) => {
        openNotification(
          "e",
          "Error de sistema",
          "Ocurrio un error en el sistema"
        );
      });
  }, []);

  const config = {
    appendPadding: 10,
    data: data30Dias,
    angleField: "clicks",
    colorField: "nombreRedireccion",
    radius: 0.8,
    label: {
      type: "outer",
      content: "{name} {percentage}",
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };

  return (
    <div>
      <div>
        <Title level={4}>
          De un total de{" "}
          {data30Dias.reduce((sum, value) => sum + value.clicks, 0)}{" "}
          interacciones.
        </Title>
      </div>
      <div className="chartContainer">
        <Pie height={1100} {...config} />
      </div>
    </div>
  );
};

export default Dashboard30DiasJoyeria;
